import React, { useEffect, useState } from "react";

const FADE = {
  IN: "animate__animated animate__fadeIn ease-in-out",
  OUT: "animate__animated animate__fadeOut ease-in-out",
};

const ANIMATION_LENGTH = 1000; // The animate__animated class has a default speed of 1s.

export const AnimatedMessages = ({ messages, wordChangeInterval = 4000 }) => {
  const [fade, setFade] = useState(FADE.OUT);
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const wordTimeout = setInterval(() => {
      setMessageIndex((previous) => (previous + 1) % messages.length);
    }, wordChangeInterval);

    return () => clearInterval(wordTimeout);
  }, []);

  useEffect(() => {
    setFade(FADE.IN);
    setTimeout(
      () => setFade(FADE.OUT),
      wordChangeInterval - ANIMATION_LENGTH,
    );
  }, [messageIndex]);

  return (
    <div className="h-6">
      <span className={fade}>{messages[messageIndex]}</span>
    </div>
  );
};
